import { PrepareCheckoutRequest, CheckoutViewModel } from '@/@types/client-api';
import { ClientAPI } from '..';

export const checkoutBaseUrl = '/commerce/checkout';

const checkoutEndpoints = ClientAPI.injectEndpoints({
  endpoints: builder => ({
    prepareCheckout: builder.query<CheckoutViewModel, PrepareCheckoutRequest>({
      query: props => ({
        url: `${checkoutBaseUrl}/prepare`,
        method: 'POST',
        body: props
      })
    })
  })
});

export const { usePrepareCheckoutQuery } = checkoutEndpoints;

export default checkoutEndpoints;
